import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import { formatLastUpdateDate } from 'srcReact/helpers/datetimeHelper'
import Actions from './Actions'
import { useTranslation } from 'react-i18next'
import Avatar from 'srcReact/components/common2/Avatar'
import { useDispatch, useSelector } from 'react-redux'
import useInfinitScroll from 'srcReact/helpers/hooks/useInfinitScroll'
import { mixrActions } from 'srcReact/Mixr/actions'
import Spinner from 'srcReact/components/common2/Spinner'
import Modal from 'srcReact/components/common2/Modal'
import Button from 'srcReact/components/common2/Button'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'

function DraftList({ search, currentOrgId, groupId, searchGroupId, handleUseMixrOrDraft, handlePreviewMixrOrDraft }) {
  const { t } = useTranslation()

  const dispatch = useDispatch()

  const {
    common: { isNative, isMobile },
    login: { user: loggedUser },
    mixr: {
      deleteDraft: { success, loading: deleteLoading, error },
      drafts: { list, stats, loading }
    }
  } = useSelector((state) => state)

  const [confirmDelete, setConfirmDelete] = useState({ id: 0, isModalOpen: false })
  const [pagination, setPagination] = useState({
    nextOffset: 0,
    isPagination: false
  })

  const lastDraftRef = useInfinitScroll(loading, stats && stats.remaining, stats && stats.next_offset, setPagination, [
    loading
  ])

  useEffect(() => {
    if (currentOrgId > 0) {
      dispatch(mixrActions.getDrafts(currentOrgId, groupId, searchGroupId, search, pagination))
    }
  }, [currentOrgId])

  useEffect(() => {
    if (success && !deleteLoading) {
      setConfirmDelete({ id: 0, isModalOpen: false })
    }
  }, [success, deleteLoading])

  useEffect(() => {
    if (currentOrgId > 0 && pagination.isPagination) {
      dispatch(mixrActions.getDrafts(currentOrgId, groupId, searchGroupId, search, pagination))
    }
  }, [pagination])

  const handleConfirmDeleteDraft = () => {
    setConfirmDelete(true)
  }

  const handleDeleteDraft = (id) => {
    setConfirmDelete({ id: id, isModalOpen: true })
  }
  const deleteDraft = (id) => {
    dispatch(mixrActions.deleteDraft(id))
  }

  return (
    <div className={styles.list}>
      {!loading && list && list.length > 0 ? (
        list.map((draft, index) => {
          const isLast = list.length === index + 1
          return (
            <div className={styles.item} ref={isLast ? lastDraftRef : null}>
              <div className={styles.info}>
                <React.Fragment>
                  <Avatar
                    imgWrapperSize='small'
                    userId={draft.user.id}
                    profilePicture={draft.user.picture.profile_picture}
                    firstname={draft.user.firstname}
                    lastname={draft.user.lastname}
                    mimeType={draft.user.picture.mime_type}
                    originalTag={draft.user.picture.original_tag}
                    isOriginal={draft.user.picture.is_original}
                    withExpertiseGroup={draft.user.with_expertise_group}
                  />
                  <button
                    onClick={() => handleUseMixrOrDraft(draft.draft_id)}
                    className={`${styles.data} ${styles.draftData}`}>
                    <h1 className={styles.name}>{draft.name}</h1>
                    <span className={styles.datetime}>{`${formatLastUpdateDate(draft.created_at, '', t)} - ${t(
                      'global.createdByUser',
                      {
                        username: `${draft.user.firstname} ${draft.user.lastname}`
                      }
                    )}`}</span>
                  </button>
                </React.Fragment>
              </div>
              <Actions
                id={draft.draft_id}
                scope='draft'
                handlePreviewMixrOrDraft={handlePreviewMixrOrDraft}
                handleUseMixrOrDraft={handleUseMixrOrDraft}
                handleDeleteDraft={handleDeleteDraft}
              />
            </div>
          )
        })
      ) : loading ? (
        <Spinner />
      ) : (
        <div
          className={styles.notFound}
          dangerouslySetInnerHTML={{
            __html: search
              ? t('event.create.startFrom.noDraftFoundSearch', { mixrName: search })
              : t('event.create.startFrom.noDraftFound')
          }}
        />
      )}
      {confirmDelete.isModalOpen && (
        <Modal
          isOpen={confirmDelete.isModalOpen}
          handleClose={() => setConfirmDelete({ id: 0, isModalOpen: false })}
          nested
          title={t('event.create.startFrom.deleteDraftWarning')}>
          <div className={styles.buttons}>
            <Button
              style='secondary'
              text={t('global.no')}
              handleClick={() => setConfirmDelete({ id: 0, isModalOpen: false })}
            />
            <Button text={t('global.yes')} handleClick={() => deleteDraft(confirmDelete.id)} />
          </div>
          {error && <ErrorMessage text={error} className={styles.error} />}
        </Modal>
      )}
    </div>
  )
}

export default DraftList
